import { fetchStoreTalkTalk, setStoreTalktalkAccount } from 'common/services/talktalk'
import { TalktalkAccount } from 'common/types/entities/api/talktalk'
import { StateKey } from 'common/utils/flipState'
import { TalkTalkParam } from 'common/types/params/talktalk'

const initialState: TalktalkAccount = {
  hasBenefit: false,
  talkPcUrl: null,
  friendCount: 0,
  talkMobileUrl: null,
  benefitName: null,
  isFriend: false,
}

const FETCH_TALKTALK = 'talktalk/FETCH_TALKTALK'
const SET_TALKTALK = 'talktalk/SET_TALKTALK'

export const fetchTalkTalk = (curState: StateKey, params: TalkTalkParam, headers?: any) => async dispatch => {
  const response = await fetchStoreTalkTalk(params, headers)
  const result = response && response.data ? response.data : initialState
  dispatch({
    curState,
    type: FETCH_TALKTALK,
    payload: result,
  })
}

export const setTalktalk = (curState: StateKey, params: TalkTalkParam, isFriend: boolean) => async dispatch => {
  const result = await setStoreTalktalkAccount(params, isFriend)

  const data = {
    isFriend: !isFriend,
    friendCount: result.data.friendCount,
  }

  dispatch({
    curState,
    type: SET_TALKTALK,
    payload: data,
  })
}

const talktalkReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TALKTALK: {
      return action.payload
    }
    case SET_TALKTALK: {
      return {
        ...state,
        isFriend: action.payload.isFriend,
        friendCount: action.payload.friendCount,
      }
    }
    default:
      return state
  }
}

export default talktalkReducer
